<template>
	<div class="nup_main">
		<div class="new_content">
			<div class="new_webposition">
				<router-link :to="{ path: '/usercenter'}">学习中心</router-link>
				<span class="nje_jiange">&gt;</span><span class="nje_last">培训记录</span></div>
			<div class="nupmrm_case">
				<div class="npm_caseDiv9" style="padding-left:0px;height:38px;">
					<div class="npm_caseDiv9_right">
						年份
						<el-date-picker
							v-model="searchForm.year"
							placeholder="选择年份"
							size="small" style="height: 24px;" type="year">
						</el-date-picker>
						<el-select v-model="searchForm.state" placeholder="请选择" size="small">
							<el-option label="学习状态-全部" value=""></el-option>
							<el-option label="未学习" value="0"></el-option>
							<el-option label="学习中" value="1"></el-option>
							<el-option label="已学完" value="2"></el-option>
							<el-option label="已申请学分" value="3"></el-option>
						</el-select>
						
						<input id="search" class="f_r" type="button" value="搜索" @click="searchList"/>
						<el-input v-model="searchForm.trainingName" class="f_r"
							placeholder="按培训名称关键字查询" size="small" style="display:inline-block;width:200px;"></el-input>
					</div>
				</div>
			</div>
			<div class="nupmrm_content">
				<el-table v-loading="listLoading" :data="trainingListInit" highlight-current-row style="width: 100%;">
					<el-table-column label="培训名称" prop="trainingName" show-overflow-tooltip width="320">
						<template slot-scope="scope">
                  <span class="w295 c-999  pr">
                    <font v-if="scope.row.businessType == 102"
	                    style="color:#1D7A8E">[继教]</font>{{ scope.row.trainingName }}
                  </span>
						</template>
					</el-table-column>
					<el-table-column label="有效期" prop="endTime" width="400">
						<template slot-scope="scope">
							<span class="w295 c-999  pr">{{ scope.row.beginTime }}至{{ scope.row.endTime }}<img
								v-if="new Date>Date.parse(scope.row.endTime.replace(/\-/g, '/'))"
								border="0" class="pic_yjs" height="26" src="../../assets/images/peixunyijieshu.png" width="54"/></span>
						</template>
					</el-table-column>
					<el-table-column label="学习状态" prop="state"></el-table-column>
					<el-table-column label="操作" width="120">
						<template slot-scope="scope">
							<!--<router-link title="查看详情" class="alb_xxzx" :to="{path: '/usercenter', query:{readOnly: scope.row.readOnly,trainingId:scope.row.businessType}}" >查看详情</router-link> &lt;!&ndash; :to="scope.row.detailHref" &ndash;&gt;-->
							<el-button size="mini" type="primary" @click="viewDetail(scope.$index, scope.row)">查看明细</el-button>
						</template>
					</el-table-column>
				</el-table>
				<el-col :span="24" class="toolbar" style="padding-top: 12px;">
					<el-pagination :current-page="searchForm.currentPage" :page-size="searchForm.pageSize"
						:total="searchForm.total" layout="total, prev, pager, next" style="float:right;"
						@current-change="handleExamCurrentChange">
					</el-pagination>
				</el-col>
			</div>
		</div>
		<!--查看非继教已过期培训班明细 -->
		<el-dialog :visible.sync="viewProjDetailPage" title="查看明细" width="90%">
			<div>
				<project-info :projectId="projectId" :trainingId="trainingId"></project-info>
			</div>
		</el-dialog>
		
		<!--查看继教已过期项目明细 -->
		<el-dialog :visible.sync="viewDetailPage" title="查看明细" width="90%">
			<div>
				<not-cme-page :currentTraining="currentTraining"></not-cme-page>
			</div>
		</el-dialog>
	</div>

</template>

<script>

import { mapGetters } from 'vuex'
import { getMyTrainingList, getTrainingById } from '../../api/api'
import ElButton from '../../../node_modules/element-ui/packages/button/src/button'
import notCmePage from '../../components/NotCmePage'
import projectInfo from '../../components/ProjectInfo'

import util from '../../common/js/util'


export default {
	components: {
		ElButton,
		notCmePage,
		projectInfo
	},
	data() {
		return {
			currentTraining: null,
			trainingListInit: [],
			viewDetailPage: false,
			viewProjDetailPage: false,
			listLoading: false,
			searchForm: {
				currentPage: 1,//当前页数
				pageSize: 10,//每页显示条目个数
				total: 0, //总条目数
				year: new Date,
				state: '',
				trainingName: '',
				userId: ''
			},
			trainingId: '',
			projectId: ''
		}
	},
	computed: {
		...mapGetters([
			'userInfo'
		])
	},
	methods: {
		
		searchList() {
			this.searchForm.currentPage = 1
			this.listTrainingInit()
		},
		
		listTrainingInit() {
			if (this.$storejs.get(process.env.APPKEY + 'token') == undefined) {
				this.$alert('请刷新检查登陆状态', '提示', {
					confirmButtonText: '确定',
					callback: action => {
						this.$router.push('/')
					}
				})
				return false
			}
			
			if (this.searchForm.year != '')
				this.searchForm.year = util.formatDate.format(new Date(this.searchForm.year), 'yyyy')
			this.listLoading = true
			getMyTrainingList({...this.searchForm, source: 'shiyan'}).then((res) => {
				this.searchForm.total = res.data.data.total
				this.trainingListInit = res.data.data.list
				this.listLoading = false
			}).catch(() => {
				this.listLoading = false
				this.$message({
					type: 'info',
					message: '加载失败！'
				})
			})
		},
		
		handleExamCurrentChange(val) {
			this.searchForm.currentPage = val
			this.listTrainingInit()
		},
		
		viewDetail(index, row) {
			if (row.businessType == 102) {
				if (!(this.$moment()).isBefore(this.$moment(row.endTime))) {
					this.trainingId = row.id
					this.projectId = row.trainingId
					this.viewProjDetailPage = true
				} else {
					this.$router.push({path: '/usercenter/projectDtail', query: {trainingId: row.id, projectId: row.trainingId}})
				}
				
			} else if (row.businessType != 102) {
				if (!(this.$moment()).isBefore(this.$moment(row.endTime))) {
					var param = {id: row.id, userId: this.userInfo.id}
					getTrainingById(param).then((res) => {
						this.currentTraining = res.data.data.training
						this.viewDetailPage = true
					}).catch(() => {
						this.listLoading = false
						this.$message({
							type: 'info',
							message: '加载失败！'
						})
					})
				} else {
					this.$router.push({path: '/usercenter', query: {trainingId: row.id}})
				}
			}
		}
		
	},
	mounted() {
		this.searchForm.userId = this.userInfo.id
		this.listTrainingInit()
	}
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/usercenter/MyTraining.vue